import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AccessState {
  accessToken: string | null;
  clientID: string | null;
  clientSecret: string | null;
  maxAge: number;
  refreshToken: string | null;
  updatedAt: string | null;
}

interface AccessStateFromDB {
  access_token: string;
  client_id: string;
  client_secret: string;
  max_age: number;
  refresh_token: string;
  update_at: string;
}

const initialState: AccessState = {
  accessToken: null,
  clientID: null,
  clientSecret: null,
  maxAge: 0,
  refreshToken: null,
  updatedAt: null,
};

export const accessChange = createSlice({
  name: "access",
  initialState,
  reducers: {
    setAccess: (state, action: PayloadAction<AccessStateFromDB>) => {
      state.accessToken = action.payload.access_token;
      state.clientID = action.payload.client_id;
      state.clientSecret = action.payload.client_secret;
      state.maxAge = action.payload.max_age;
      state.refreshToken = action.payload.refresh_token;
      state.updatedAt = action.payload.update_at;
    },
    clearAccess: (state, action) =>{
      state.accessToken = initialState.accessToken;
      state.clientID = initialState.clientID;
      state.clientSecret = initialState.clientSecret;
      state.maxAge = initialState.maxAge;
      state.refreshToken = initialState.refreshToken;
      state.updatedAt = initialState.updatedAt;
    },
  },
});

export const { setAccess,clearAccess } = accessChange.actions;

export default accessChange.reducer;
